module.exports = __webpack_public_path__ + "static/avocado-5a9b5274226dda58d457338c53bb82fe.png";